<template>
  <modal v-if="showModal" @close="closeModal">
    <template slot="header">
      <h4 class="modal-title">Issue Quote</h4>
      <md-button
        class="md-simple md-just-icon md-round modal-default-button"
        @click="closeModal"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>

    <template slot="body">
      <md-field>
        <label>Quote (&#163;)</label>
        <md-input v-model="form.quote" md-select-on-focus></md-input>
      </md-field>
      <md-field>
        <label>Description</label>
        <md-textarea v-model="form.note" md-autogrow required></md-textarea>
      </md-field>
      <span v-show="errorList.length > 0" class="text-danger">{{
        errorList[0]
      }}</span>
    </template>

    <template slot="footer">
      <md-button
        class="md-success md-sm"
        @click.native.prevent="onSubmit"
        :disabled="hasSubmit"
      >
        <md-icon class="material-icons">check</md-icon>Issue Quote</md-button
      >&nbsp;
      <md-button class="md-danger md-sm" @click.native.prevent="closeModal">
        <md-icon class="material-icons">close</md-icon>Close</md-button
      >
    </template>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { Modal } from "@/components";
export default {
  components: {
    Modal
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    newStatusId: {
      type: Number,
      default: -1
    }
  },
  computed: {
    ...mapGetters({
      statInspItem: "stat-insp/statInspItem"
    })
  },
  data() {
    return {
      hasSubmit: false,
      errorList: [],
      form: {
        note: "",
        quote: "",
        statInspItemStatus: -1,
        statInspItemId: undefined
      }
    };
  },
  methods: {
    clearModal() {
      this.form.note = "";
      this.form.quote = "";
      this.form.statInspItemStatus = -1;
      this.hasSubmit = false;
      this.errorList = [];
    },
    closeModal() {
      this.clearModal();
      this.$emit("closeModal", false);
    },
    async onSubmit() {
      this.hasSubmit = true;
      this.errorList = [];
      this.form.statInspItemStatus = parseInt(this.newStatusId);
      this.form.quote = parseFloat(this.form.quote);
      this.form.statInspItemId = this.$route.params.statInspItemId;
      this.$store
        .dispatch("stat-insp/createStatInspItemQuote", this.form)
        .then(() => {
          this.clearModal();
          this.$emit("closeModal", true);
        })
        .catch(error => {
          this.hasSubmit = false;
          if (error.response.status === 400) {
            // handle validation error
            if (error.response.data.errors != undefined) {
              let validationErrorDictionary = error.response.data.errors;
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.errorList.push(
                    "- " + validationErrorDictionary[fieldName]
                  );
                }
              }
            } else {
              this.errorList.push(error.response.data);
            }
          } else {
            this.errorList.push(error.response.data);
          }
        });
    }
  }
};
</script>

<style></style>
